module.exports = __webpack_public_path__ + "static/media/blood-5.86f8f1ae.png";